import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY_MS = 6000;
const VISIBLE_MS = 5000;
const INTERVAL_MS = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const first = window.setTimeout(show, FIRST_DELAY_MS);
    const loop = window.setInterval(show, INTERVAL_MS);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-25" data-mp="116d05weotvch">
      <AnimatePresence data-id="element-26" data-mp="1fxn05tg4o4gf">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-brand-100" data-id="element-27" data-mp="1ay0kldctuc4g">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-brand-50 object-contain" aria-hidden="true" data-id="element-28" data-mp="s8aqksgw1udl" />
            <div className="min-w-0" data-id="element-29" data-mp="23lwjmopvcg4e">
              <p className="text-sm leading-snug text-ink" data-id="element-30" data-mp="23kv7si113plm">
                <strong data-id="element-31" data-mp="2apcquxqc6xgv">{buyer.name}</strong> from <strong data-id="element-32" data-mp="2ao1mavp2hlop">{buyer.place}</strong>
              </p>
              <p className="text-sm leading-snug text-ink/70" data-id="element-33" data-mp="2fn4qkdx83nvm">just purchased REFLEXOLOGY 360°™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-34" data-mp="2km7l34fkubpc">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="2pmdlb8zwx6j1" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500" aria-label="Close notification" data-id="element-36" data-mp="1rvz3bdoydtba">
              <XIcon className="h-4 w-4" data-id="element-37" data-mp="198dlrz4zbiwb" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}